import { getConfig } from '@cian/config/browser';

function getFilters() {
    const filterStrings = getConfig().get('logger.browser.errorFilter');
    return (filterStrings || []).map(filterString => new RegExp(filterString));
}

export { getFilters };
//# sourceMappingURL=getFilters.mjs.map
